import React from 'react';
import { Field } from 'formik';

import styles from './feeStructureFormStyles';

import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
import RadioField from 'buyside/components/presentation/Form/Field/RadioField/radioField';
import DocumentsForm from 'buyside/components/presentation/Form/DocumentsForm/documentsForm';

// NOTE: make sure to update the appropriate schema in util/fundProfileShowPageValidationSchemata

const radioOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false }
];

const FeeStructureForm = () => {
  return (
    <div>
      <div className={styles.feeStructureFormMainArea}>
        <div className={styles.feeStructureFormColumn}>
          <Field
            component={InputField}
            name="fundProfile.managementFee"
            label="Management Fee"
            addon="%"
          />
          <Field
            component={InputField}
            name="fundProfile.incentiveFee"
            label="Incentive Fee"
            addon="%"
          />
          <Field
            component={InputField}
            name="fundProfile.hurdleRate"
            label="Hurdle Rate"
            addon="%"
          />
          <Field component={InputField} name="fundProfile.lockUp" label="Lock Up" addon="months" />
        </div>
        <div className={styles.feeStructureFormColumn}>
          <Field
            component={RadioField}
            name="fundProfile.highwaterMark"
            label="Highwater Mark"
            options={radioOptions}
          />
          <Field
            component={RadioField}
            name="fundProfile.seedDeal"
            label="Seed Deals"
            options={radioOptions}
          />
          <Field
            component={RadioField}
            name="fundProfile.foundersShares"
            label="Founder's Shares"
            options={radioOptions}
          />
          <Field
            component={RadioField}
            name="fundProfile.investorLevelGates"
            label="Investor-Level Gates"
            options={radioOptions}
          />
        </div>
      </div>
      <DocumentsForm
        title="Supporting Documents"
        attr="fundProfile.feeStructureDocuments"
        withDescription
        withMargin
      />
    </div>
  );
};

export default FeeStructureForm;
